module.exports = __webpack_public_path__ + "static/img/pingjieshen2.689e2f09.png";